<script>
  import { _ as t } from "svelte-i18n";
  import { format } from "date-fns";
  import { it, enUS } from "date-fns/locale";
  import { Icon } from "t2c-components";

  import { getLanguage } from "i18n/language.js";
  import { google, yahoo, off365, ics } from "calendar.js";
  import { Button, Title } from "t2c-components";

  export let item;
  export let onClose;

  $: datetime = new Date(`${item.date}T${item.eventTime}`);
  let locale = $getLanguage === "it" ? it : enUS;

  const iconColor = (icon) => {
    // https://coolors.co/0d1b2a-1b263b-415a77-778da9-e0e1dd
    switch (icon) {
      case "case":
        return "#aaa";
      case "document":
        return "#778da9";
      case "law":
        return "#1b263b";
      case "handshake":
        return "#415a77";
      default:
        return "#000";
    }
  };

  const tooltipText = (item) => {
    switch (item.__typename) {
      case "Lawcase":
        return $t("timeline.newCase");
      case "Event":
        if (item.category === "Judge") {
          return $t("timeline.newJudgeEvent");
        } else {
          return $t("timeline.newExtraEvent");
        }
      case "Document":
        return $t("timeline.newDocument");
    }
  };

  const handleGoogle = () => {
    const link = google(item);
    window.open(link, "_blank");
  };

  const handleYahoo = () => {
    const link = yahoo(item);
    window.open(link, "_blank");
  };

  const handleIcs = () => {
    const link = ics(item);
    window.open(link, "_blank");
  };

  const handleClose = () => {
    onClose();
  };
</script>

<div class="center">
  <Title>{$t("timeline.detail")}</Title>
</div>
<div class="intro">
  <div class="circle" style={`background-color: ${iconColor(item.icon)}`}>
    <Icon big icon={item.icon} stroke="white" />
  </div>
</div>
<div class="detail">
  <div class="entry-header">{$t("timeline.typeOfEvent")}:</div>
  <div class="entry-content">{tooltipText(item)}</div>
  <div class="entry-header">{$t("timeline.name")}:</div>
  <div class="entry-content">{item.title}</div>
  <div class="entry-header">{$t("timeline.description")}:</div>
  <div class="entry-content">{item.description}</div>
  <div class="entry-header">{$t("timeline.date")}:</div>
  <div class="entry-content">
    {format(new Date(datetime), "EEEE d MMMM yyyy", { locale })}
  </div>
  <div class="entry-header">{$t("timeline.time")}:</div>
  <div class="entry-content">
    {format(new Date(datetime), "HH:mm", { locale })}
  </div>
</div>

<p class="calendar-hint">{$t("timeline.export")}:</p>
<div class="calendars">
  <span on:click={handleGoogle}>Google</span>
  <span on:click={handleYahoo}>Yahoo</span>
  <span on:click={handleIcs}>{$t("timeline.local")}</span>
</div>
<div class="actions">
  <Button on:click={handleClose}>{$t("common.close")}</Button>
</div>

<style>
  .center {
    text-align: center;
  }

  .intro {
    margin-top: 24px;
    margin-bottom: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .circle {
    width: 92px;
    height: 92px;
    border: 1px solid white;
    border-radius: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .detail {
    margin: 24px 0;
    display: grid;
    grid-template-columns: 100px 1fr;
  }

  .entry-header {
    margin: 6px 0;
    font-weight: 700;
    font-size: 14px;
  }

  .entry-content {
    margin: 6px 0;
    font-size: 14px;
  }

  .calendar-hint {
    margin-top: 48px;
  }

  .calendars {
    display: flex;
    align-items: center;
    color: #999;
  }

  .calendars > * {
    transition: 0.3s color ease-in-out;
    cursor: pointer;
  }

  .calendars > *:hover {
    color: black;
  }

  .calendars > * + * {
    margin-left: 12px;
  }

  .actions {
    display: flex;
    justify-content: flex-end;
  }
</style>
